import React from 'react'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero';
import About from '../components/About';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
const Home = () => {
  return (
    <div className='bg-[#2A2A2A]'> 
        <Navbar />
        <section id="home">
        <Hero/>
        </section>
        <section id="about">
        <About/>
          </section> 
          <section id="skill">
            <Skills/>
            </section>
            <section id="experience">
              <Experience/>
              </section> 
    </div>
  )
}

export default Home